import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OrderReceiptComponent } from './components/order-receipt/order-receipt.component';
import { LiveCartComponent } from "./components/live-cart/live-cart.component";
import { GiftCardReceiptComponent } from "./components/gift-card-receipt/gift-card-receipt.component";
import { StartShiftComponent } from "./components/cash-apron/start-shift/start-shift.component";
import { CashDropComponent } from "./components/cash-apron/cash-drop/cash-drop.component";
import { EndShiftComponent } from "./components/cash-apron/end-shift/end-shift.component";
import { TipComponent } from "./components/tip/tip.component";

@NgModule({
    imports: [RouterModule.forChild([
        {
            path: 'start-shift/:apronId',
            component: StartShiftComponent
        },
        {
            path: 'cash-drop/:apronId',
            component: CashDropComponent
        },
        {
            path: 'end-shift/:apronId',
            component: EndShiftComponent
        },
        {
            path: 'check/:cartId',
            component: LiveCartComponent
        },
        {
            path: 'giftCard',
            component: GiftCardReceiptComponent
        },
        {
            path: 'tiptok',
            component: TipComponent
        },
        {
            path: '',
            pathMatch: 'full',
            component: OrderReceiptComponent
        },
    ])],
    exports: [RouterModule]
})
export class WebOrderReceiptRoutingModule {
}
